export const img = (name, sizes = "100vw") => ({
  src: `/images/${name}-1600.webp`,
  srcSet: `/images/${name}-800.webp 800w, /images/${name}-1600.webp 1600w`,
  sizes,
});

export const mediaImg = (url, sizes = "100vw") => {
  if (!url?.startsWith("/api/media/")) return { src: url };
  return { src: url, srcSet: `${url}?w=800 800w, ${url} 1600w`, sizes };
};
